import { TApplicationState } from '../../types/redux';

export function getRegionId(state: TApplicationState): number | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.regionId) {
    return geo.regionId;
  }

  return null;
}
